import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { BedSvg, CalendarIconSvg, MoonIconSvg, InfoIconSvg, UserIconSvg, ShipIconSvg } from "../../assets/svg";
import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { approveRejectSSRRequest } from "../../api/quotation.api";
import { usePrivateContext } from "../../context/private.context";
import { sortBy } from "lodash";
import { splitDate } from "../../utils/splitDate";
import SnackbarContext from "../../context/snackbar.context";
import CustomModal from "../../components/ModalWrapper/ModalWrapper";
import CustomButton from "../../components/CustomButton/CustomButton";
import dayjs from "dayjs";

interface ISSRTableRow {
  item: any;
  index: number;
  ssrData: any;
  setSSRData: Dispatch<SetStateAction<any>>;
};
interface IPayload {
  quotationItemId: string;
  specialRequestId: string[];
  approvalRemarks: string;
};

const approverEmails = ['rohini.b@cordeliacruises.com', 'keshav.p@cordeliacruises.com', 'deep.m@cordeliacruises.com'];

const SSRTableRow:React.FC<ISSRTableRow> = ({ item, index, ssrData, setSSRData }) => {
  const snackbarCtx = useContext(SnackbarContext);
  const { auth: { authData: { firstName, lastName, email } } } = usePrivateContext();
  const [openActionModal, setOpenActionModal] = useState<boolean>(false);
  const [openViewDetailsModal, setOpenViewDetailsModal] = useState<boolean>(false);
  const [payloadObj, setPayloadObj] = useState<IPayload>({
    quotationItemId: item?.quotationItemId,
    specialRequestId: item?.specialRequests
      .filter((request: any) => request?.status === "REQUESTED_FOC")
      .map((request: any) => request?.specialRequestId),
    approvalRemarks: "",
  });
  
  useEffect(() => {
    if (!!ssrData.length) { 
      const sortedArr = sortBy(ssrData?.[index]?.specialRequests, (item) => new Date(item.updatedAt));
      const tempData = [...ssrData];
      tempData[index].specialRequests = [...sortedArr.reverse()];
      setSSRData([...tempData]);
    }
  }, [ssrData?.length]);

  const handleRemarksChange = (e: any) => {
    const { value } = e.target;
    setPayloadObj((prevPayload: any) => ({ ...prevPayload, approvalRemarks: value }));
  };

  const handleBtnClick = async (status: string) => {
    const data = await approveRejectSSRRequest({ ...payloadObj, status: status })
    if (data.status === 201) {
      const tempData = [...ssrData];
      tempData[index].specialRequests[0].status = status;
      tempData[index].specialRequests[0].approvedBy = { firstName: firstName, lastName: lastName };
      tempData[index].specialRequests[0].approvalRemarks = payloadObj.approvalRemarks;
      setSSRData([...tempData]);
      setOpenActionModal(prev => !prev)
      snackbarCtx.toggleSnackbar({
        message: `Special request ${(status.replace(/^FOC_|_FOC$/g, "")).toLowerCase()}!`,
        type: "SUCCESS",
        visible: true,
      });
    } else {
      snackbarCtx.toggleSnackbar({
        message: data?.response?.data?.message,
        type: "FAILURE",
        visible: true,
      });
    }
  };

  const formatNumberWithCommas = (specialReqArr: { price: number }[] = []) => {
    if (!Array.isArray(specialReqArr)) {
      return "₹0.00";
    }
    let totalAmount: number = specialReqArr.reduce((acc, specialReq) => acc + specialReq.price, 0);
    return new Intl.NumberFormat('en-IN', { style: "currency", currency: "INR" }).format(totalAmount);
  };
  
  return (
    <div className="min-h-[171px] my-3 border rounded bg-light">
      <Row className="bg-[#F9FFF2] border-bottom rounded-top min-h-[34px] m-0 flex items-center " style={{ fontSize: "16px", fontWeight: "700" }}>
        <Col><p className="m-0">SSR Items - {item?.specialRequests?.length || 0} ॥ SSR Discount Total - {formatNumberWithCommas(item?.specialRequests || [])}</p></Col>
        <Col className="flex justify-end items-center">
          <p className="px-2 m-0 text-[#92278F]">{item?.quotation?.number}</p>
          <p className="px-2 m-0 "><span className={`${item?.specialRequests?.[0]?.status === 'REQUESTED_FOC' ? "text-[#FFA500]" : item?.specialRequests?.[0]?.status === 'FOC_APPROVED' ? "text-[#17A300]" : "text-[#e3444a]"}`}>
            {item?.specialRequests?.[0]?.status.replace(/^FOC_|_FOC$/g, "")}
            </span>
            </p>
        </Col>
      </Row>
      <Row className="text-[#7A7A7A] mx-0 mt-3" style={{ fontSize: "14px", lineHeight: "18.23px" }}>
      <Col xs={4} className="flex items-center">
          <p className="mx-1 my-auto text-uppercase"> {item?.quotation?.routeName}</p>
        </Col>
        <Col>
          <p className="m-0" style={{ fontWeight: "400" }}>Full Name</p>
          <p className="m-o" style={{ fontWeight: "700" }}>{item?.quotation?.customer?.firstName} {item?.quotation?.customer?.lastName}</p>
        </Col>
        <Col>
          <p className="m-0" style={{ fontWeight: "400" }}>Phone Number</p>
          <p className="m-o" style={{ fontWeight: "700" }}>{item?.quotation?.customer?.phoneNumber}</p>
        </Col>
        <Col>
          <p className="m-0" style={{ fontWeight: "400" }}>Email</p>
          <p className="m-o" style={{ fontWeight: "700" }}>{item?.quotation?.customer?.email}</p>
        </Col>
      </Row>
      <div className="m-0 mt-4 px-3 flex items-center justify-evenly flex-wrap text-[#7A7A7A]" style={{ fontSize: "17px", fontWeight: "500" }}>
        <Col className="flex items-center">
          <CalendarIconSvg height={19} width={19} fill="#7a7a7a"/>
          <p className="mx-1 my-auto whitespace-nowrap">{dayjs(splitDate(item?.quotation?.itinerary?.startTime)).format("DD MMM YYYY")} - {dayjs(splitDate(item?.quotation?.itinerary?.endTime)).format("DD MMM YYYY")}</p>
        </Col>
        <Col className="flex items-center">
          <ShipIconSvg fill="#7a7a7a" height={20} width={18} />
          <span className="mx-1 my-auto">Cruise: {item?.quotation?.itinerary?.shipName || item?.quotation?.shipName || 'NA'}</span>
        </Col>
        <Col className="flex items-center">
          <MoonIconSvg fill="#7a7a7a" />
          <p className="mx-1 my-auto">{item?.quotation?.nights} Nights</p></Col>
        <Col className="flex items-center">
          <UserIconSvg fill="#7a7a7a" />
          <p className="mx-1 my-auto">{(Number(item?.quotation?.infants) || 0) + (Number(item?.quotation?.children) || 0) + (Number(item?.quotation?.adults) || 0)} Guests</p>
          <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
            overlay={
              <Tooltip>
                  {`Adult: ${item?.quotation?.adults || 0}`}
                  <br />
                  {`Children: ${item?.quotation?.children || 0}`}
                  <br />
                  {`Infant: ${item?.quotation?.infants || 0}`}
              </Tooltip>
            }>
            <span className="cursor-pointer">
              <InfoIconSvg fill="#D0566E" />
            </span>
          </OverlayTrigger>
        </Col>
        <Col className="flex items-center">
          <BedSvg fill="#7a7a7a" />
          <p className="mx-1 my-auto">{item?.quotation?.items?.length || 0} {item?.quotation?.items?.length > 1 ? 'Cabins' : 'Cabin'}</p>
          <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
            overlay={
              <Tooltip>
                  {item?.quotation?.items?.length && item?.quotation?.items?.map((cabin: any) => <>{cabin?.categoryName}<br/></>)}
              </Tooltip>
            }>
            <span className="cursor-pointer">
              <InfoIconSvg fill="#D0566E" />
            </span>
          </OverlayTrigger>
        </Col>
      </div>
      <Row className="mt-4 mb-3 pr-[7%]">
        <div className="flex items-center justify-end gap-3 flex-wrap">
          <CustomButton fillColor={false} onButtonClick={() => setOpenViewDetailsModal(prev => !prev)}>View Details</CustomButton>
          {item?.specialRequests?.[0]?.status === 'REQUESTED_FOC' && item?.quotation?.status === 'ACTIVE' && approverEmails.includes(email) &&
          <CustomButton onButtonClick={() => setOpenActionModal(prev => !prev)}>Take Action</CustomButton>}
        </div>
      </Row>
      <CustomModal show={openActionModal} handleClose={()=> setOpenActionModal(prev => !prev) }>
        <div className="sm:min-w-[30vw] min-w-[75vw] flex flex-col gap-4">
          <span>Special Service Request</span>
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
              {item?.specialRequests?.map((specialReqItem: { status: string, specialRequest: { price: number, name: string } }) => {
                return (specialReqItem?.status === 'REQUESTED_FOC' ? 
                  <div className="flex justify-between text-base font-semi-bold text-muted">
                    <span>{specialReqItem?.specialRequest?.name} :</span>
                    <span>{new Intl.NumberFormat('en-IN', { style: "currency", currency: "INR" }).format(specialReqItem?.specialRequest?.price ?? 0)}</span>
                  </div> : <></>
                )})
              }
            </div>
            <div className="flex justify-between flex-wrap text-base font-semi-bold text-muted">
              <span className="w-1/2 whitespace-nowrap">Request Remarks :</span>
              <span className="text-sm font-medium self-end italic w-fit max-h-[30vh] overflow-auto break-all">{item?.specialRequests?.[0]?.requestRemarks}</span>
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-2 request-textarea-wrapper">
            <label htmlFor="remarks">Add Remarks</label>
            <textarea
              name="remarks"
              id="reamrks"
              className="w-100 min-h-[60px]"
              placeholder="Remarks"
              onChange={handleRemarksChange}
            ></textarea>
          </div>
          <div className="flex justify-center flex-wrap gap-4">
            <CustomButton fillColor={false} disabled={!payloadObj?.approvalRemarks} onButtonClick={() => handleBtnClick('FOC_REJECTED')}>Reject Request</CustomButton>
            <CustomButton disabled={!payloadObj?.approvalRemarks} onButtonClick={() => handleBtnClick('FOC_APPROVED')}>Approve Request</CustomButton>
          </div>
        </div>
      </CustomModal>
      <CustomModal show={openViewDetailsModal} handleClose={()=> setOpenViewDetailsModal(prev => !prev) }>
        <div className="min-w-[30vw] flex flex-col gap-4">
          <span>Special Service Request</span>
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
              {item?.specialRequests?.map(( specialReqItem: { status: string, specialRequest: { price: number, name: string } }) => {
                return (
                  <div className="flex justify-between text-base font-semi-bold text-muted w-100">
                    <span>{specialReqItem?.specialRequest?.name} :</span>
                    <div className="flex items-center justify-between w-1/2">
                      <span className={`text-sm font-thin ${specialReqItem?.status ==='REQUESTED_FOC' ? "text-[#FFA500]" : specialReqItem?.status ==='FOC_APPROVED' ? "text-[#17A300]" : "text-[#e3444a]"}`}>{specialReqItem?.status?.replace(/^FOC_|_FOC$/g, "")}</span>
                      <span>{new Intl.NumberFormat('en-IN', { style: "currency", currency: "INR" }).format(specialReqItem?.specialRequest?.price ?? 0)}</span>
                    </div>
                  </div>
                )})
              }
            </div>
            <div className="flex justify-between text-base font-semi-bold text-muted">
              <span className="w-1/2">Request raised by :</span>
              <span className="text-base font-medium self-end w-fit max-h-[10vh] overflow-auto break-all capitalize">{item?.specialRequests?.[0]?.requestedBy?.firstName + ' ' + item?.specialRequests?.[0]?.requestedBy?.lastName}</span>
            </div>
            <div className="flex justify-between text-base font-semi-bold text-muted">
              <span className="w-1/2">Remarks :</span>
              <span className="text-sm font-medium self-end italic w-fit max-h-[10vh] overflow-auto break-all">{item?.specialRequests?.[0]?.requestRemarks}</span>
            </div>
            {!!item?.specialRequests?.[0]?.approvedBy && <div className="flex justify-between text-base font-semi-bold text-muted">
              <span className="w-1/2">Request raised to :</span>
              <span className="text-base font-medium self-end w-fit max-h-[10vh] overflow-auto break-all capitalize">{item?.specialRequests?.[0]?.approvedBy?.firstName + ' ' + item?.specialRequests?.[0]?.approvedBy?.lastName}</span>
            </div>}
            {!!item?.specialRequests?.[0]?.approvalRemarks && <div className="flex justify-between text-base font-semi-bold text-muted">
              <span className="w-1/2">Remarks :</span>
              <span className="text-sm font-medium self-end italic w-fit max-h-[10vh] overflow-auto break-all">{item?.specialRequests?.[0]?.approvalRemarks}</span>
            </div>}
          </div>
        </div>
      </CustomModal>
    </div>
  )
}
export default SSRTableRow